import { render, staticRenderFns } from "./logs.vue?vue&type=template&id=35beb510"
import script from "./logs.vue?vue&type=script&lang=js"
export * from "./logs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports